import Popup from './components/Popup';
import Close from './components/Close';
import MapBox from './components/MapBox';
import Filters from './components/Filters';
import MapBoxLocations from './components/MapBoxLocations';
import Overlay from './components/Overlay';

export default options => {
  options.maps.forEach(map => {
    if (map.isModal) {
      try {
        const { trigger, data, disableScrollZoom, initialCameraSettings, assetsFilters } = map;
        const { translation } = options;

        if (!trigger) {
          throw new Error('[AQUILA-CAPITAL-MAP] Trigger object is not defined');
        }

        if (!data) {
          throw new Error('[AQUILA-CAPITAL-MAP] Data is not defined');
        }

        const visibleAssets = assetsFilters.map(filter => filter.value);

        const overlay = new Overlay();
        const popup = new Popup();
        const mapBox = new MapBox(data, translation, disableScrollZoom, initialCameraSettings);
        const closeButton = new Close(() => {
          popup.close();

          trigger.classList.remove('ac-map__trigger--opened');
          document.body.classList.remove('ac-map--opened');
        });

        const filters = new Filters(
          assetsFilters,
          visibleAssets,
          activeFilters => {
            // toggling a filters callback
            const filteredData = data.source.data.features.filter(({ properties }) =>
              activeFilters.includes(properties.assetClass)
            );

            mapBox.setData(filteredData);
          },
          () => {
            // reset callback
            mapBox.setData(data.source.data.features);
            mapBox.reset();
          },
          translation,
          initialCameraSettings
        );

        // create popup with bellow elements
        const popupElements = [closeButton, filters, mapBox];
        popupElements.forEach(element => popup.appendElement(element.getElement()));

        trigger.classList.add('ac-map__trigger--loading');

        popup.render();

        mapBox.init(() => {
          trigger.classList.remove('ac-map__trigger--loading');
        });

        trigger.addEventListener('click', e => {
          if (e.target.classList.contains('ac-map__trigger--loading')) return;

          popup.toggle();

          trigger.classList.toggle('ac-map__trigger--opened');
          document.body.classList.toggle('ac-map--opened');
        });
      } catch (error) {
        console.error(error.message);
      }
    } else {
      try {
        const { container, data, hideMarkerPopup, initialCameraSettings } = map;
        const { translation } = options;

        if (!container) {
          throw new Error('[AQUILA-CAPITAL-MAP] Container object is not defined');
        }

        if (!data) {
          throw new Error('[AQUILA-CAPITAL-MAP] Data is not defined');
        }

        if (container) {
          const mapBoxLocations = new MapBoxLocations(
            container,
            'ac-map__map-box-container',
            data,
            hideMarkerPopup,
            translation,
            initialCameraSettings
          );

          mapBoxLocations.init();
        }
      } catch (error) {
        console.error(error.message);
      }
    }
  });
};
